(exports.GAME_ID = "6103ad547da1830015b527e8"),
(exports.FORM_ID = "6103ad547da1830015b527e9"),
(exports.STATUS_ID = "6103ad547da1830015b527ea"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-Husqvarnav2");
